import { map } from 'ramda'

/**
 * Basket import line module actions.
 *
 * @param {FetchPath} fetchPath
 * @param {Function} yodaFormatter
 * @returns {Object}
 */
export default ({ fetchPath, yodaFormatter }) => ({
  /**
   * Index lines for a given import.
   *
   * @param {Function} commit
   * @param {Object} parameters
   * @returns {Promise<Array>}
   */
  async xhrIndex({ commit }, { parameters = {} }) {
    const response = await fetchPath.run({
      method: 'GET',
      path: '/yoda/api/basket-file-import-lines',
      parameters,
      jsonPath: ['content', 'data'],
    })
    const entities = map(yodaFormatter, response)

    await commit('SET_ENTITIES', { entities })

    return entities
  },
})
